import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Copy, Check } from "lucide-react";
import { copyToClipboard } from "@/lib/utils";

interface CopyButtonProps {
  text: string;
  variant?: "default" | "outline" | "ghost" | "link";
  size?: "default" | "sm" | "lg";
  className?: string;
  children?: React.ReactNode;
}

export const CopyButton: React.FC<CopyButtonProps> = ({
  text,
  variant = "outline",
  size = "sm",
  className = "",
  children,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent parent click handlers
    const success = await copyToClipboard(text);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleCopy}
      className={`${className} ${copied ? "bg-green-50 border-green-200" : ""}`}
    >
      {copied ? (
        <>
          <Check className="w-3 h-3 mr-1 text-green-600" />
          {children || "Copied!"}
        </>
      ) : (
        <>
          <Copy className="w-3 h-3 mr-1" />
          {children || "Copy"}
        </>
      )}
    </Button>
  );
};
